import { createTheme, type Theme } from '@mui/material/styles';
import { createAppTheme } from './Theme';
import components from './Components';
export const widgetColorKeys = [
  'background',
  'accent',
  'messageBackground',
  'accentText',
  'text',
  'secondaryText',
] as const;
export type WidgetColorKey = (typeof widgetColorKeys)[number];
export const validWidgetColor = (value: string) => /^#[0-9a-f]{6}$/i.test(value);
/** User-authored values enter the MUI palette only through this bounded semantic adapter. */
export const createWidgetTheme = (colors: Partial<Record<WidgetColorKey, string>>): Theme => {
  const base = createAppTheme();
  const color = (key: WidgetColorKey, fallback: string) =>
    colors[key] && validWidgetColor(colors[key]!) ? colors[key]! : fallback;
  const theme = createTheme(base, {
    palette: {
      background: {
        default: color('background', base.palette.background.default),
        paper: color('background', base.palette.background.paper),
      },
      primary: {
        main: color('accent', base.palette.primary.main),
        contrastText: color('accentText', base.palette.primary.contrastText),
      },
      text: {
        primary: color('text', base.palette.text.primary),
        secondary: color('secondaryText', base.palette.text.secondary),
      },
      surface: {
        ...base.palette.surface,
        sunken: color('messageBackground', base.palette.surface.sunken),
      },
    },
  });
  theme.components = components(theme) as Theme['components'];
  return theme;
};
